import { styled } from "@mui/material";

// Styled wrapper reused from the main calendar page to keep visuals identical.
const FullCalendarWrapper = styled("div")(({ theme }) => ({
  "& .fc-license-message": {
    display: "none",
  },
  "& .fc": {
    "--fc-bg-event-opacity": 1,
    "--fc-border-color": theme.palette.divider,
    "--fc-daygrid-event-dot-width": "10px",
    "--fc-event-text-color": theme.palette.text.primary,
    "--fc-list-event-hover-bg-color": theme.palette.background.default,
    "--fc-neutral-bg-color": theme.palette.background.default,
    "--fc-page-bg-color": theme.palette.background.default,
    "--fc-today-bg-color": theme.palette.primary.main + "40",
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
  },
  "& .fc .fc-col-header-cell-cushion": {
    paddingBottom: "10px",
    paddingTop: "10px",
  },
  "& .fc .fc-day-other .fc-daygrid-day-top": {
    color: theme.palette.text.secondary,
  },
  "& .fc-daygrid-event": {
    padding: "10px",
  },
  "& .fc-timeGridWeek-view": {
    "& .fc-scrollgrid-section-liquid": {
      display: "none",
    },
    "& .projectric-all-day": {
      height: "600px",
    },
  },
  "& .fc-timeGridDay-view": {
    "& .fc-scrollgrid-section-liquid": {
      display: "none",
    },
    "& .projectric-all-day": {
      height: "600px",
    },
  },
  "& .fc-dayGridMonth-view": {
    "& .fc-daygrid-day-number": {
      width: "100%",
    },
  },
}));

export default FullCalendarWrapper;

